module.exports = __webpack_public_path__ + "fonts/Proxima-Nova-Font.bf9f5d50.otf";